import { FC } from 'react';
import { IconV2 } from '@abtasty/design-system';
import { useTranslation } from 'react-i18next';
import { useSegmentTrack } from '@src/application/hooks/useSegment/useSegment';
import styles from './CloseButton.module.scss';
import { onQaAssistantClosing } from '@application/modules/shared/util';
import { MSG_NAME_FROM_IFRAME, sendMessageFromIframe } from '@src/container/handleIframeMessage/handleIframeMessage';

export const CloseButton: FC = () => {
  const { t } = useTranslation();
  const tooltipText = t('Close');
  const segmentTrack = useSegmentTrack();
  return (
    <button
      data-testid="close-button"
      type="button"
      aria-label={tooltipText}
      className={styles.closeButton}
      onClick={() => {
        segmentTrack('QA - Click closing button');
        sendMessageFromIframe({ name: MSG_NAME_FROM_IFRAME.QaAssistantClose });
        onQaAssistantClosing();
      }}
    >
      <IconV2
        icon="close"
        tooltipTargetClassName={styles.tooltip}
        tooltipType="small"
        tooltip={{ content: tooltipText }}
      />
    </button>
  );
};
